import { CreateScene, DeleteScene, EntityScene, ModelScene, IndexScene, UpdateScene, useEntity } from 'components';
import { useRoutes } from 'react-router';
import { Company } from 'types';
import { permissions } from 'modules/supplier/agreement/permissions';
import { Form } from 'modules/supplier/agreement/Form';
import { Link } from 'react-router-dom';
import { dateFrom, dateTo } from 'components/columns';
import { ReactElement } from 'react';
import { ProviderAgreement } from 'modules/supplier/agreement/types';
import { ControlledTableColumns } from 'components/ControlledTable';
import { ProviderAgreementPartition } from 'modules/supplier/agreement/ProviderAgreementPartition';
import { Nav } from './Nav';

const columns: ControlledTableColumns<ProviderAgreement> = [
  {
    content: 'Number',
    key: 'number',
    required: true,
    width: 180,
    render: ({ id, number }: ProviderAgreement) => <Link to={`${id}`}>{number}</Link>,
  },
  dateFrom({ sortable: true }),
  dateTo({ sortable: true }),
];

function copy(agreement: ProviderAgreement): any {
  const { id: _id, types: _types, ...values } = agreement;
  return {
    ...values,
    date_from: null,
    date_to: null,
    number: '',
    attachments: [],
  };
}

export function Agreements(): ReactElement {
  const { item } = useEntity<Company>();

  const model = {
    endpoint: `supplier/providers/${item.id}/agreements/`,
    title: 'Provider agreement',
    pluralTitle: 'Provider agreements',
    entityTitle: (e: ProviderAgreement) => e.number,
    permissions,
  };

  const routes = useRoutes([
    {
      index: true,
      element: <IndexScene columns={columns} />,
    },
    {
      path: 'create',
      element: (
        <CreateScene>
          <Form />
        </CreateScene>
      ),
    },
    {
      path: ':id/',
      element: (
        <EntityScene>
          <Nav />
        </EntityScene>
      ),
      children: [
        {
          index: true,
          element: (
            <UpdateScene viewDisabled={true} copy={copy}>
              <Form />
            </UpdateScene>
          ),
        },
        {
          path: 'discounts/:type',
          element: <ProviderAgreementPartition />,
        },
        {
          path: 'delete',
          element: <DeleteScene />,
        },
      ],
    },
  ]);
  return <ModelScene {...model}>{routes}</ModelScene>;
}
